import React from 'react';

import { FormInputText } from '../../../common/formInputsV2/FormInputText';
import { FormInputSelect } from '../../../common/formInputsV2/FormInputSelect';
import { communePopulation, fascia, typeOfOrganizations } from '../../../common/constants';
import FormReactSelectResidenceInput from '../../../common/formInputsV2/FormReactSelectResidenceInput';
import FormReactSelectSimpleMulti from '../../../common/formInputs/FormReactSelectSimpleMulti';
import ReactSelecPublicoImpiego from '../../../common/formInputs/ReactSelecPublicoImpiego';
import { SurfaceCard, SurfaceCardHeader, SurfaceCardHeading } from '../../../common/formInputsV2/Card.styles';

function OrganizationData({
  isValid,
  error_organization_name,
  organization_name,
  values,
  register,
  error_type_of_organization,
  type_of_organization,
  municipalities,
  residence_commune_code_name,
  residence_province_code_name,
  updateFormData,
  insured_position,
  commune_population,
  error_commune_population,
  error_insured_position,
  error_residence_province_code,
}) {
  return (
    <SurfaceCard>
      <SurfaceCardHeader>
        <SurfaceCardHeading>Inserisci queste informazioni</SurfaceCardHeading>
      </SurfaceCardHeader>
      <div>
        <FormInputText
          placeholder="Denominazione Ente"
          label="Denominazione Ente"
          value={values.organization_name}
          error={error_organization_name}
          registration={register(`${organization_name}`)}
          valid={isValid(organization_name, 'organization_name')}
        />
        <FormReactSelectResidenceInput
          label="Provincia Sede"
          options={municipalities}
          values={{
            residence_commune_code: values.residence_commune_code,
            residence_province_code: values.residence_province_code,
          }}
          onChange={(values) => updateFormData({
            [`${residence_commune_code_name}`]: values.residence_commune_code,
            [`${residence_province_code_name}`]: values.residence_province_code,
          })}
          valid={isValid('residence_commune_code')}
          error={error_residence_province_code}
        />

        <ReactSelecPublicoImpiego
          options={typeOfOrganizations.sort((a, b) => a.name.localeCompare(b.name, 'it', { sensitivity: 'base' }))}
          error={error_type_of_organization}
          valid={isValid(type_of_organization, 'type_of_organization')}
          label="Tipologia di ente"
          onChange={(val) => {
            if (val.type_of_organization !== 'amministrazioni_comunali') {
              updateFormData({
                [`${type_of_organization}`]: val.type_of_organization,
                [`${commune_population}`]: '',
              });
            } else {
              updateFormData({ [`${type_of_organization}`]: val.type_of_organization });
            }
          }}
          values={{
            type_of_organization: values.type_of_organization,
          }}
        />

        {values.type_of_organization === 'amministrazioni_comunali'
           && (
           <FormInputSelect
             label="Abitanti"
             registration={register(commune_population)}
             error={error_commune_population}
             valid={isValid(commune_population, 'commune_population')}
             placeholder="-Seleziona-"
             options={communePopulation}
             value={values.error_commune_population}

           />
           )}

        <FormReactSelectSimpleMulti
          label="Tipologia di Carica Assicurata"
          options={fascia.sort((a, b) => a.name.localeCompare(b.name, 'it', { sensitivity: 'base' }))}
          value={values.insured_position}
          onChange={(val) => updateFormData({ [`${insured_position}`]: val })}
          valid={isValid(insured_position, 'insured_position')}
          placeholder="-Seleziona-"
          error={error_insured_position}
        />

      </div>
    </SurfaceCard>
  );
}

export default OrganizationData;
